<template>
  <div class="live-wrapper">
    <span class="close-icon" @click="docloseLive"></span>
    <div class="player-wrapper" v-show="isHtml">
      <iframe :src="url" frameborder="0"></iframe>
    </div>
    <div class="player-wrapper" v-show="!isHtml">
      <video class="video-js vjs-big-play-centered" id="video_live" controls preload="auto" autoplay></video>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LivePlayer',
  props: ['closeLive', 'videoUrl'],
  data () {
    return {
      url: '',
      player: null,
      isHtml: false,
    }
  },
  mounted () {
    let self = this
    /* eslint-disable */
    // let video_url = 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8'
    let media_type = ''
    if (this.videoUrl.indexOf('.m3u8') !== -1) {
      media_type = 'application/x-mpegURL'
      this.isHtml = false
    } else if (this.videoUrl.indexOf('.mp4') !== -1) {
      media_type = 'video/mp4'
      this.isHtml = false
    } else {
      this.isHtml = true
    }
    if (this.isHtml) {
      this.url = this.videoUrl
    } else {
      this.player = videojs(document.getElementById('video_live'))
      this.player.on('ready', function() {
        self.player.src({
          src: self.videoUrl,
          type: media_type
        })
      })
    }
  },
  methods: {
    docloseLive () {
      if (this.isHtml) {
        this.closeLive && this.closeLive()
        return
      }
      this.player.dispose()
      this.player = null
      this.$nextTick(() => {
        this.closeLive && this.closeLive()
      })
    }
  }
}
</script>

<style scoped>
  .live-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background-color: rgba(0,0,0,0.6);
  }
  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    z-index: 200;
    background-image: url('../../assets/close.png');
    background-size: 100% 100%;
    cursor: pointer;
  }
  .player-wrapper {
    width: 100%;
    height: 100%;
  }
  .video-js {
    width: 100%;
    height: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
</style>